module.exports = __webpack_public_path__ + "static/media/malestise_ettepanek.4720dfee.png";